import React, { FC } from "react";
import { LuUsers } from "react-icons/lu";

import { RoleModel } from "../../../factories/role/role.model";
import { Avatar } from "../../newUI/avatar";

type Props = {
  role?: RoleModel;
};

export const RoleMembersPreview: FC<Props> = ({ role }) => {
  const members = role?.userRoles || [];

  return (
    <div
      className={
        "flex max-h-[250px] w-[225px] flex-col overflow-hidden rounded-[10px] border border-[#E4E9F2] bg-white font-Manrope text-[13px] shadow-lg"
      }>
      <div
        className={
          "border-b border-[#EEF1F5] px-4 py-2 text-[13px] font-extrabold text-[#1F2433]"
        }>
        Members
      </div>

      {members.length ? (
        <div className={"overflow-y-auto py-2"}>
          {members.map((member) => (
            <div
              className={"flex items-center gap-2 px-4 py-1.5"}
              key={member.id}>
              <Avatar
                id={member.user.id || member.id}
                fullName={`${member.user.userProfile.firstName || ""} ${
                  member.user.userProfile.lastName || ""
                }`.trim()}
                color={member.user.userProfile.color}
                size={"sm"}
                avatarClassNames={"h-6 w-6 shrink-0 text-[10px] font-bold"}
              />
              <div
                className={
                  "min-w-0 truncate text-[13px] font-semibold text-[#3A4256]"
                }>
                {member.user.userProfile.firstName}{" "}
                {member.user.userProfile.lastName}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div
          className={"flex flex-col items-center gap-2 px-4 py-5 text-center"}>
          <span
            className={
              "flex h-9 w-9 items-center justify-center rounded-full bg-[#F4F2FF] text-[#6B4EFF]"
            }>
            <LuUsers size={18} strokeWidth={1.9} />
          </span>
          <div className={"text-[13px] font-bold text-[#3A4256]"}>
            No members in this role
          </div>
          <div className={"text-xs font-medium leading-5 text-[#8A92A3]"}>
            Users assigned to this role will appear here.
          </div>
        </div>
      )}
    </div>
  );
};
